import { captureException as sentryCatchError } from '@sentry/browser'

export function captureException (e) {
  if (!process.env.VUE_APP_SENTRY_DISABLED) {
    sentryCatchError(e)
  } else {
    console.error(e)
  }
}
